<template>
  <div id="donate-step2">
    <component
      :is="recipientForm"
      @success="processSuccess"
    ></component>
  </div>
</template>

<script>
import AdoptionRecipient from "./AdoptionRecipient.vue";
import WildcardRecipient from "./WildcardRecipient.vue";

import { mapState } from "vuex";

export default {
  name: "RecipientDetails",
  components: {
    AdoptionRecipient,
    WildcardRecipient
  },

  computed: {
    recipientForm() {
      if (this.product.producttype == "adoption") {
        return "AdoptionRecipient";
      }
      if (this.product.producttype == "wildcard") {
        return "WildcardRecipient";
      }
      return null;
    },
    ...mapState({
      product: (state) => state.product.product,
    }),
  },

  methods: {
    processSuccess() {
      this.$emit("next");
    }
  },
};
</script>


// WEBPACK FOOTER //
// RecipientDetails.vue?71c0fbc1